(function () {
  'use strict';

  var config = window.NovaWear && window.NovaWear.overlayTiming;
  if (!config || !config.enabled) return;

  var releaseAt = Date.now() + Math.max(0, config.delayWithoutBanner || 0);
  var revealTimer = null;
  var markedOverlays = [];
  var klaviyoRetryTimers = [];

  function isKlaviyoFormEvent(event) {
    if (!event || !event.detail) return false;
    return event.detail.type === 'open' || event.detail.type === 'show';
  }

  function findKlaviyoOverlays() {
    var selectors = [
      '[data-testid="POPUP"]',
      '[data-testid="POPUP_FORM"]',
      '[data-testid*="klaviyo"][role="dialog"]',
      '.klaviyo-form[role="dialog"]'
    ];
    var matches = [];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        var overlay = element.closest('[data-testid="POPUP"], [role="dialog"]') || element;
        if (matches.indexOf(overlay) === -1) matches.push(overlay);
      });
    });

    return matches;
  }

  function revealMarkedOverlays() {
    window.clearTimeout(revealTimer);
    revealTimer = null;
    markedOverlays.forEach(function (overlay) {
      if (overlay && overlay.removeAttribute) overlay.removeAttribute('data-nova-marketing-overlay');
    });
    markedOverlays = [];
    document.dispatchEvent(new CustomEvent('nova:marketing-overlay-ready'));
  }

  function scheduleReveal() {
    window.clearTimeout(revealTimer);
    revealTimer = window.setTimeout(revealMarkedOverlays, Math.max(0, releaseAt - Date.now()));
  }

  function markKlaviyoOverlays() {
    if (Date.now() >= releaseAt) {
      revealMarkedOverlays();
      return;
    }

    findKlaviyoOverlays().forEach(function (overlay) {
      if (overlay.closest && overlay.closest('pandectes-cmp, #pandectes-banner, #shopify-pc__banner')) return;
      overlay.setAttribute('data-nova-marketing-overlay', '');
      if (markedOverlays.indexOf(overlay) === -1) markedOverlays.push(overlay);
    });
    scheduleReveal();
  }

  function cancelKlaviyoRetries() {
    klaviyoRetryTimers.forEach(window.clearTimeout);
    klaviyoRetryTimers = [];
  }

  function handleKlaviyoForm(event) {
    if (!isKlaviyoFormEvent(event)) return;
    cancelKlaviyoRetries();
    [0, 50, 150, 350].forEach(function (delay) {
      klaviyoRetryTimers.push(window.setTimeout(markKlaviyoOverlays, delay));
    });
  }

  function holdAfterConsent() {
    releaseAt = Date.now() + Math.max(0, config.delayAfterConsent || 0);
    markKlaviyoOverlays();
  }

  function holdWhileConsentOpens() {
    releaseAt = Number.MAX_SAFE_INTEGER;
    markKlaviyoOverlays();
  }

  document.addEventListener('klaviyoForms', handleKlaviyoForm);
  document.addEventListener('visitorConsentCollected', holdAfterConsent);
  window.addEventListener('PandectesEvent_OnConsent', holdAfterConsent);
  window.addEventListener('PandectesEvent_OnBannerClose', holdAfterConsent);
  window.addEventListener('PandectesEvent_OnBannerShow', holdWhileConsentOpens);
  window.addEventListener('PandectesEvent_OnPreferencesOpen', holdWhileConsentOpens);

  window.addEventListener('pagehide', function () {
    cancelKlaviyoRetries();
    window.clearTimeout(revealTimer);
  });
})();
